import clsx from 'clsx';
import styles from './Grid.module.scss';

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  role?: string;
  columns?: number;
  minWidth?: number;
  equalGap?: boolean;
}

export const Grid = ({ children, role, columns = 1, minWidth, equalGap, ...props }: GridProps) => (
  <div
    className={clsx(styles.grid, {
      [styles.equalGap]: equalGap,
    })}
    role={role}
    style={
      {
        '--grid-columns': columns,
        '--grid-min-width': minWidth ? `${minWidth / 16}rem` : undefined,
      } as React.CSSProperties
    }
    {...props}
  >
    {children}
  </div>
);
